import * as Yup from "yup";

import { variables } from "../../Variables";

const { required, IsEmail } = variables;

export const addvalidation = Yup.object({
  email: Yup.string().required(required).email(IsEmail),
  name: Yup.string()
    .required(required)
    .test("len", "Must be less than 22 characters", (val) => val.length <= 22)
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
  population: Yup.number().required(required),
});
